'use strict';

module.exports = require('./components/TinyMCE');


//////////////////
// WEBPACK FOOTER
// ./~/react-tinymce/lib/main.js
// module id = 478
// module chunks = 0